import { Chip } from "../../chip/Chip";
import { selectedValueChip } from "../common/Select.css";
import { Option } from "../common/SelectBase";
import {
  TriggerContentWrapper,
  TriggerText
} from "../common/TriggerContentWrapper";

/**
 * Default maximum number of chips to display before showing "+N" chip.
 * This value is set to 1 to ensure that only one chip is displayed by default,
 * with additional selected values summarized in a "+N" chip for better readability.
 */
const MAX_COUNT = 1;
export interface MultiSelectTriggerValueProps {
  /**
   * Array of selected option values
   */
  selectedValues: string[];
  /**
   * List of all available options
   */
  options: Option[];
  /**
   * Callback to toggle selection of an option
   */
  toggleOption: (value: string) => void;
  /**
   *  Placeholder text when no values are selected
   */
  placeholder?: string;
  /**
   * Whether the component is disabled
   */
  disabled?: boolean;
}

export function MultiTriggerValue({
  selectedValues,
  options,
  placeholder,
  disabled = false,
  toggleOption
}: MultiSelectTriggerValueProps): React.ReactElement {
  return (
    <TriggerContentWrapper>
      {!selectedValues.length ? (
        <TriggerText text={placeholder} />
      ) : (
        <>
          {selectedValues.slice(0, MAX_COUNT).map((value) => {
            const label =
              options.find((option) => option.value === value)?.label ?? value;
            return (
              <Chip
                key={value}
                onClose={() => toggleOption(value)}
                disabled={disabled}
              >
                {label}
              </Chip>
            );
          })}
          {selectedValues.length > MAX_COUNT && (
            <Chip className={selectedValueChip} disabled={disabled}>
              +{selectedValues.length - MAX_COUNT}
            </Chip>
          )}
        </>
      )}
    </TriggerContentWrapper>
  );
}
